(() => {
  const intent = (value) => {
    let terms = value.trim();
    let min = '', max = '';
    const between = terms.match(/(?:between\s*)?\$?([\d,]+(?:\.\d{1,2})?)\s*(?:-|to|and)\s*\$?([\d,]+(?:\.\d{1,2})?)/i);
    const under = terms.match(/(?:under|below|up to|less than)\s*\$?([\d,]+(?:\.\d{1,2})?)/i);
    if (between && (/between|\$/.test(between[0]))) {
      min = Number(between[1].replaceAll(',', ''));
      max = Number(between[2].replaceAll(',', ''));
      if (min > max) [min, max] = [max, min];
      terms = terms.replace(between[0], ' ');
    } else if (under) {
      max = Number(under[1].replaceAll(',', ''));
      terms = terms.replace(under[0], ' ');
    }
    terms = terms.replace(/\b(?:bc|british columbia|alaska|yukon)\b/gi, 'Alaskan')
      .replace(/\b(?:aussie|australia)\b/gi, 'Australian')
      .replace(/\bjewellery\b/gi, 'jewelry')
      .replace(/\bgold\s+(?:and|with)\s+quartz\b/gi, 'gold quartz')
      .replace(/\s+/g, ' ').trim();
    return { terms: terms || 'gold', min, max };
  };
  const searchUrl = (action, parsed) => {
    const url = new URL(action, location.origin);
    url.searchParams.set('q', parsed.terms);
    url.searchParams.set('type', 'product');
    url.searchParams.set('filter.v.availability', '1');
    if (parsed.min !== '') url.searchParams.set('filter.v.price.gte', parsed.min);
    if (parsed.max !== '') url.searchParams.set('filter.v.price.lte', parsed.max);
    return url;
  };
  const score = (current, candidate) => {
    if (current.family !== candidate.family || current.id === candidate.id) return -1;
    if (current.family === 'other' && (!current.kind || current.kind !== candidate.kind)) return -1;
    if (current.family === 'nugget' && current.kind !== 'natural' && current.kind !== candidate.kind) return -1;
    if (current.family === 'jewelry' && current.kind !== candidate.kind) return -1;
    let result = current.kind === candidate.kind ? 60 : 0;
    if (current.origin && current.origin === candidate.origin) result += 25;
    if (current.family === 'nugget' && current.weight > 0 && candidate.weight > 0) {
      const ratio = Math.min(current.weight, candidate.weight) / Math.max(current.weight, candidate.weight);
      result += ratio * 25;
    }
    if (current.price > 0 && candidate.price > 0) result += Math.min(current.price, candidate.price) / Math.max(current.price, candidate.price) * 20;
    return result >= 50 ? result : -1;
  };
  window.NbgShopping = { intent, searchUrl, score };

  if (!customElements.get('nbg-product-matches')) {
    customElements.define('nbg-product-matches', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.current = JSON.parse(this.dataset.profile);
        this.cards = new Map();
        this.add(this.querySelector('template').content);
        this.paint();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
          }, { rootMargin: '500px' });
          this.observer.observe(this);
        } else this.load();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
      add(root) {
        root.querySelectorAll('[data-nbg-profile]').forEach((card) => {
          try {
            const profile = JSON.parse(card.dataset.nbgProfile);
            if (profile.available && profile.id !== this.current.id && !this.cards.has(profile.id)) this.cards.set(profile.id, { profile, card });
          } catch {}
        });
      }
      paint() {
        const ranked = [...this.cards.values()].map((item) => ({ ...item, rank: score(this.current, item.profile) }))
          .filter((item) => item.rank >= 0).sort((a, b) => b.rank - a.rank || a.profile.price - b.profile.price);
        const similar = ranked.slice(0, 4);
        const less = ranked.filter((item) => item.profile.price < this.current.price && item.profile.price >= this.current.price * 0.3 && !similar.includes(item)).slice(0, 3);
        const draw = (target, items) => {
          if (!target) return;
          target.replaceChildren(...items.map((item) => item.card.cloneNode(true)));
        };
        draw(this.querySelector('[data-match-grid]'), similar);
        this.querySelector('[data-match-row]').hidden = similar.length === 0;
        draw(this.querySelector('[data-less-grid]'), less);
        this.querySelector('[data-less-row]').hidden = less.length === 0;
        draw(document.querySelector('[data-nbg-sold-target]'), similar);
      }
      async load() {
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 8000);
        try {
          const response = await fetch(this.dataset.url, { signal: this.controller.signal, credentials: 'same-origin' });
          if (!response.ok) return;
          this.add(new DOMParser().parseFromString(await response.text(), 'text/html'));
          if (this.isConnected) this.paint();
        } catch {} finally { clearTimeout(timeout); }
      }
    });
  }

  if (!customElements.get('nbg-piece-chooser')) {
    customElements.define('nbg-piece-chooser', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.form = this.querySelector('form');
        const type = this.querySelector('[name="piece"]');
        const style = this.querySelector('[name="style"]');
        type.addEventListener('change', () => {
          const jewelry = type.value.includes('jewelry');
          style.closest('label').hidden = jewelry;
          if (jewelry) style.value = 'any';
        });
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this.choose(); });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async choose() {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const data = new FormData(this.form);
        const piece = data.get('piece'), style = data.get('style'), budget = data.get('budget');
        const option = this.querySelector(`[name="piece"] option[value="${piece}"]`);
        const styleOption = this.querySelector(`[name="style"] option[value="${style}"]`);
        const destination = piece.includes('jewelry') ? option.dataset.url : (styleOption.dataset.url || option.dataset.url);
        const url = new URL(destination, location.origin);
        url.searchParams.set('filter.v.availability', '1');
        url.searchParams.set('sort_by', 'best-selling');
        if (piece === 'nuggets' && style === 'any') {
          url.pathname = this.dataset.search;
          url.searchParams.set('q', 'nugget -earrings -pendant -ring -jewelry -stud -bail');
          url.searchParams.set('type', 'product');
          url.searchParams.set('sort_by', 'relevance');
        }
        if (budget) url.searchParams.set('filter.v.price.lte', budget);
        const more = this.querySelector('[data-choice-more]');
        more.href = url.toString(); more.hidden = false;
        const status = this.querySelector('[role="status"]');
        status.textContent = this.dataset.loading;
        const target = this.querySelector('[data-choice-results]');
        target.replaceChildren(); target.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          url.searchParams.set('section_id', 'nbg-choice-cards');
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Results unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const cards = [...html.querySelectorAll('[data-nbg-product-id]')].slice(0, 4);
          if (controller !== this.controller || !this.isConnected) return;
          target.replaceChildren(...cards);
          status.textContent = cards.length ? this.dataset.found.replace('__count__', cards.length) : this.dataset.empty;
        } catch {
          if (controller === this.controller) status.textContent = this.dataset.error;
        } finally {
          clearTimeout(timeout);
          if (controller === this.controller) target.removeAttribute('aria-busy');
        }
      }
    });
  }
})();
